// extracted by mini-css-extract-plugin
module.exports = {"item":"_941","cover":"_570","content":"_16932","name":"_8750","info":"_442","price":"_2945","unit":"_18189","value":"_7180","sales":"_3396"};